import { inject, injectable } from 'inversify';
import { HttpServiceBase } from '@/bases/services/HttpServiceBase';
import { GetScheduleResponse } from '@/models';
import { ShowCallInfoResponse } from '@/models';
import { ShowCallResponse } from '@/models';
import { AxiosPromise } from 'axios';

@injectable()
export class VisitourService extends HttpServiceBase {
  public constructor() {
    super();
  }

  public ShowCallInfo(extID: string | null): AxiosPromise<ShowCallInfoResponse> {
    return this.Get<ShowCallInfoResponse>(
      `api/Visitour/ShowCallInfo?extID=${extID}`, {
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
    });
  }

  public GetSchedule(extID: string | null): AxiosPromise<GetScheduleResponse> {
    return this.Get<GetScheduleResponse>(
      `api/Visitour/GetSchedule?extID=${extID}`, {
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
    });
  }
}